import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { 
  Grid, 
  Card, 
  Box, 
  Typography, 
  FormControl, 
  TextField, 
  Button, 
  FormControlLabel, 
  Checkbox,
  Snackbar,
  Alert
} from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const CreatePaymentTermForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    publish: false,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API_ENDPOINTS.PAYMENT_TERMS.CREATE, {
        name: formData.name,
        publish: formData.publish,
      });
      
      setSnackbar({
        open: true,
        message: "Payment term created successfully!",
        severity: "success",
      });

      // Navigate after a short delay to allow the success message to be seen
      setTimeout(() => {
        navigate("/payment-terms");
      }, 1500);
    } catch (error) {
      console.error("Error creating payment term:", error.response?.data || error.message);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Error creating payment term. Please try again.",
        severity: "error",
      });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Add A Payment Term
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Payment Term Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="publish"
                      checked={formData.publish}
                      onChange={handleChange}
                    />
                  }
                  label="Publish"
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button type="submit" variant="contained">
                Create Payment Term
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreatePaymentTermForm;